<template>
  <v-card
    tile
    width="60%"
    shaped
    elevation="12"
    class="jf-card mx-auto mt-6"
  >
    <!-- Header -->
    <v-btn icon v-if="parent">
      <v-icon :title="parent" />
    </v-btn>
    <v-card-text>{{ parent }}</v-card-text>
    <v-card-title>{{ title }}</v-card-title>

    <v-divider />
    <!-- Body -->
    <slot name="body" />
  </v-card>
</template>

<script>
export default {
  name: "Card",
  props: ["title", "topic", "parent", "body"]
};
</script>

<style scoped>

</style>
